import Vue from "vue"
import VueRouter from "vue-router"
// import setDocuemntTtitle from "@/utils/setDocumentTitle"
// import store from "@/store"

const home = () => import("../views/Home/index")
const poster = () => import("../views/Poster/index")
const nothingnessActivity = () => import("../views/NothingnessActivity/index")
//const posterCard = () => import("../views/Poster/PosterCardImg/index.vue")
Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: "/",
    name: "home",
    meta: {
      title: "",
      keepAlive: true
    },
    component: home
  },
  {
    path: "/poster",
    name: "poster",
    meta: {
      title: "",
      keepAlive: false
    },
    component: poster
  },
  {
    path: "/nothingnessActivity",
    name: "nothingnessActivity",
    meta: {
      title: "",
      keepAlive: false
    },
    component: nothingnessActivity
  }
  // ,
  // {
  //   path: "/",
  //   name: "poster",
  //   meta: {
  //     title: "",
  //     keepAlive: false
  //   },
  //   component: posterCard
  // }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  // const activityTitle = store.state.activityInfo.activityDetail.activityName
  // const title = to.meta.title ? to.meta.title : activityTitle ? activityTitle : ""
  // if (title) {
  //   setDocuemntTtitle(title)
  // }
  next()
})

export default router
